var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
import { BrandClientService } from '../../../../../services/modules/brand-client.service';
import * as Enumerable from 'linq';
import { NotificationClientService } from '../../../../../services/basics/notification-client.service';
import { I18N } from 'aurelia-i18n';
import { LookupClientService } from '../../../../../services/lookups/lookup-client.service';
import { CurrencyClientService } from '../../../../../services/modules/currency-client.service';
var ManageCurrenciesDialog = /** @class */ (function () {
    function ManageCurrenciesDialog(dialogClient, brandClientService, lookupClientService, currencyClientService, notificationService, i18N) {
        this.dialogClient = dialogClient;
        this.brandClientService = brandClientService;
        this.lookupClientService = lookupClientService;
        this.currencyClientService = currencyClientService;
        this.notificationService = notificationService;
        this.i18N = i18N;
        this.currencies = [];
    }
    ManageCurrenciesDialog.prototype.cancel = function () {
        this.dialogClient.hide();
    };
    ManageCurrenciesDialog.prototype.save = function () {
        var e_1, _a, e_2, _b;
        var currencyIds = Enumerable.from(this.currencies).where(function (x) { return x.isSelected; }).select(function (x) { return x.currencyId; });
        var currenciesToDelete = Enumerable.from(this.vm.lotteryPricingModel.lotteryBrandPrices).where(function (x) { return !currencyIds.contains(x.currencyId); }).select(function (x) { return x; }).toArray();
        try {
            for (var currenciesToDelete_1 = __values(currenciesToDelete), currenciesToDelete_1_1 = currenciesToDelete_1.next(); !currenciesToDelete_1_1.done; currenciesToDelete_1_1 = currenciesToDelete_1.next()) {
                var item = currenciesToDelete_1_1.value;
                var index = this.vm.lotteryPricingModel.lotteryBrandPrices.indexOf(item);
                this.vm.lotteryPricingModel.lotteryBrandPrices.splice(index, 1);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (currenciesToDelete_1_1 && !currenciesToDelete_1_1.done && (_a = currenciesToDelete_1.return)) _a.call(currenciesToDelete_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        try {
            for (var _c = __values(currencyIds.toArray()), _d = _c.next(); !_d.done; _d = _c.next()) {
                var item = _d.value;
                this.vm.lotteryPricingModel.lotteryBrandPrices.push({
                    currencyId: item,
                    lotteryPricingModelId: this.vm.lotteryPricingModel.lotteryPricingModelId,
                    countryId: 0,
                    lotteryBrandPriceId: null,
                    price: 0,
                    shouldUpdateCurrencyRate: false
                });
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this.dialogClient.hide();
    };
    ManageCurrenciesDialog.prototype.activate = function (model) {
        var _this = this;
        if (!model)
            return;
        this.vm = model;
        this.currencyClientService.getCurrencies().then(function (x) {
            var e_3, _a;
            _this.currencies = x;
            try {
                for (var _b = __values(_this.currencies), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var currency = _c.value;
                    currency.isSelected = Enumerable.from(_this.vm.lotteryPricingModel.lotteryBrandPrices).select(function (x) { return x.currencyId; }).contains(currency.currencyId);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
        });
    };
    ManageCurrenciesDialog = __decorate([
        transient(),
        autoinject(),
        __metadata("design:paramtypes", [DialogClientService, BrandClientService, LookupClientService,
            CurrencyClientService, NotificationClientService, I18N])
    ], ManageCurrenciesDialog);
    return ManageCurrenciesDialog;
}());
export { ManageCurrenciesDialog };
